import ActionTypes from "./types";

export default () => {
  return {
    type: ActionTypes.RESET_SEARCH_CLAIMS_RESULTS,
  };
};
